import { render, staticRenderFns } from "./txt2.vue?vue&type=template&id=6a58ebe3"
import script from "./txt2.vue?vue&type=script&lang=js"
export * from "./txt2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports